<script>
  import AdminFeatureCard from "./AdminFeatureCard.svelte";
  import AdminLlmSettings from "./AdminLlmSettings.svelte";

  export let features;

  export const sections = [
    {
      title: "Main Areas",
      description: "Top-level project areas available to users.",
      settings: [
        ["mainAreas", "taskMiningProjects", "Task Mining Project"],
        ["mainAreas", "potentialScoutProjects", "Potential Scout Project"],
        ["mainAreas", "systemIntelligence", "System Intelligence"],
        ["mainAreas", "processIntelligence", "Process Intelligence"],
        ["mainAreas", "companySettings", "Company Settings"],
        ["mainAreas", "showAllProjectsAsArchived", "Show all projects as archived"],
      ],
    },
    {
      title: "Project Progress",
      description: "Cards shown in the project overview.",
      settings: [
        ["platformFeatures", "newProject", "New Project"],
        ["projectProgress", "blacklisting", "Blacklisting"],
        ["projectProgress", "startWhitelistPhase", "Start Whitelist Phase action"],
        ["projectProgress", "startTaskRegistration", "Start Task Registration action"],
        ["projectProgress", "checkAnonymization", "Check Anonymization"],
        ["projectProgress", "numberAssistant", "Number Assistant"],
        ["projectProgress", "discoveryExtended", "Discovery Extended"],
        ["projectProgress", "preprocessData", "Discovery Extended: Preprocess Data"],
      ],
    },
    {
      title: "Platform Features",
      description: "Navigation and analysis controls available to users.",
      settings: [
        ["platformFeatures", "guidedTours", "Guided Tours"],
        ["platformFeatures", "registrationsGlobalSwitch", "Registrations / Global switch"],
        ["platformFeatures", "demoSoftwareIntelligence", "Demo Software Intelligence"],
        ["platformFeatures", "frameworkAssistant", "Framework Assistant"],
        ["platformFeatures", "metricsFilter", "Metrics Filter"],
        ["platformFeatures", "mainWindowTitles", "Main: Window Titles & UI Elements"],
        ["platformFeatures", "registrationUiElements", "Registrations: UI Elements"],
        ["platformFeatures", "licenseCatalog", "Software Intelligence: License Catalog"],
        ["processExplorer", "aiBot", "AI Bot"],
        ["processExplorer", "filters", "Filters"],
        ["kpiMatrix", "taskKpiSetup", "Task KPI Setup"],
        ["analysisViews", "changeAnalysisDemoModels", "Change Analysis Demo"],
      ],
    },
    {
      title: "Analysis Views",
      description: "Analysis views available in the main navigation.",
      settings: [
        ["analysisViews", "appDrilldown", "App Drilldown"],
        ["analysisViews", "appFlow", "App Flow"],
        ["analysisViews", "workloads", "App Users"],
        ["analysisViews", "shortcutAnalysis", "Shortcut Analysis"],
        ["analysisViews", "processExplorer", "Process Explorer"],
        ["analysisViews", "caseExplorer", "Object Explorer"],
        ["analysisViews", "kpiMatrix", "KPI Matrix"],
        ["analysisViews", "changeAnalysis", "Change Analysis"],
      ],
    },
    {
      title: "Process Explorer Exports",
      description: "Export options offered in the Process Explorer.",
      settings: [
        ["exports", "image", "Image PNG"],
        ["exports", "bpmn", "BPMN 2.0"],
        ["exports", "reportPdf", "Report PDF"],
        ["exports", "actionPlan", "Action Plan"],
        ["exports", "pdd", "PDD"],
        ["exports", "sop", "SOP"],
        ["exports", "createWorkflowN8n", "Create Workflow (N8N)"],
      ],
    },
  ];

  // Allgemeine Einstellungen: Benutzermenue plus die Sprachmodell-Weiche (Cloud / lokal).
  const generalSettings = {
    title: "General Settings",
    description: "User menu options and the language model used by the platform.",
    settings: [["userMenu", "showAccountSettings", "Show Account Settings"]],
  };
</script>

<div class="settings-grid">
  {#each sections as section}
    <AdminFeatureCard
      bind:features
      title={section.title}
      description={section.description}
      settings={section.settings}
    />
  {/each}
  <AdminFeatureCard
    bind:features
    title={generalSettings.title}
    description={generalSettings.description}
    settings={generalSettings.settings}
  >
    <div slot="footer">
      <AdminLlmSettings />
    </div>
  </AdminFeatureCard>
</div>

<style>
  .settings-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 22rem), 1fr));
    gap: 1rem;
  }

</style>
